import React from 'react';
import { Button } from '@/components/common';
import { cn } from '@/utils/cn';
import type { AppNotification } from '../../types';
import { markAsRead, resolveNotification } from '../../utils/notification-actions';
import { useAppStore } from '@/store/useAppStore';

interface Props {
  notification: AppNotification;
}

export const RosterUpdateCard: React.FC<Props> = ({ notification }) => {
  const user = useAppStore(state => state.auth.user);
  const changes = (notification.payload?.changes as Array<{ field: string }>) || [];
  const isResolved = notification.resolved === true;

  const handleAccept = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (user?.uid) await resolveNotification(user.uid, notification.id);
  };

  const handleDismiss = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (user?.uid) await markAsRead(user.uid, notification.id);
  };

  return (
    <div className="mt-1">
      {changes.length > 0 && (
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Changed: {changes.map(c => c.field).join(', ')}
        </p>
      )}

      {!isResolved && (
        <div className="flex gap-2 mt-1.5">
          <Button
            onClick={(e) => { void handleAccept(e); }}
            variant="subtle"
            size="xs"
            className={cn(
              'text-xs px-2 py-0.5 rounded font-medium',
              'bg-primary/10 text-primary hover:bg-primary/20 transition-colors',
            )}
          >
            Accept
          </Button>
          <Button
            onClick={(e) => { void handleDismiss(e); }}
            variant="secondary"
            size="xs"
            className={cn(
              'text-xs px-2 py-0.5 rounded font-medium',
              'bg-gray-100 dark:bg-white/10 text-gray-500 dark:text-gray-400',
              'hover:bg-gray-200 dark:hover:bg-white/20 transition-colors',
            )}
          >
            Dismiss
          </Button>
        </div>
      )}

      {isResolved ? <p className="text-xs text-emerald-500 mt-1">Resolved</p> : null}
    </div>
  );
};
